module.exports = __webpack_public_path__ + "img/other_oppo2.2fafa645.jpg";